import { useCallback } from 'react';

interface UseAddToCartValidationParams {
    productTypeName?: string;
    variation?: unknown;
}

export const useAddToCartValidation = ({ productTypeName, variation }: UseAddToCartValidationParams) => {
    const validateAddToCart = useCallback(() => {
        return !(productTypeName === 'ConfigurableProduct' && !variation);
    }, [productTypeName, variation]);

    return {
        validateAddToCart,
    };
};
